<div class="form-group mr-1 mb-0">
  <div class="btn-group position-relative" dropdown [isDisabled]="disabled">
    <button
      [disabled]="disabled"
      dropdownToggle
      class="btn btn-sm btn-outline-secondary dropdown-toggle"
    >
      {{ dataVersionDisplay }}
    </button>
    <div>
      <ul
        *dropdownMenu
        class="custom-menu scroll-size dropdown-menu"
        role="menu"
      >
        <li role="menuitem" *ngFor="let dv of dataVersions">
          <span
            class="dropdown-item small px-2 py-1"
            [ngClass]="{ active: dv.value === defaultDataVersion }"
            (click)="changeDataVersion(dv.value)"
          >
            {{ dv.display }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</div>
